/* eslint-disable import/prefer-default-export */
export const SET_GROUPING = 'VISITING_MEMBERS/SET_GROUPING';
